// Mobilný panel vyhľadávania — slovenské dvojče locale/cs/mobileSearch.js.
export default {
  back: 'Späť',
  clear: 'Vymazať dopyt',
  popular: 'Najhľadanejšie',
  cats: 'Najčastejšie kategórie',
  cta: 'Zobraziť všetky výsledky',
};
